export default __webpack_public_path__ + "static/media/HrsPortfolio.1d2cc789.png";